import { Modal, Table } from "react-bootstrap";
import configData from "../config";
import StripeCheckout from "react-stripe-checkout";
const stripKEY = configData?.stripePublicKey;

const CheckoutPaymentModel = ({
  show,
  logoUrl,
  logoRedirectUrl,
  handleClose,
  selectedItems,
  totalPrice,
  isLoading,
  handleToken,
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        closeButton
        style={{ textAlign: "center", alignItems: "center" }}
      >
        <a
          href={logoRedirectUrl || "/"}
          target={logoRedirectUrl ? "_blank" : "_self"}
          rel="noopener noreferrer"
        >
          <img
            src={logoUrl}
            alt="logo"
            style={{
              height: "auto",
              width: "auto",
              maxHeight: 70,
              maxWidth: 165,
            }}
          />
        </a>
      </Modal.Header>
      <Modal.Body>
        <Modal.Title className="mb-2">Selected Protection Plans</Modal.Title>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Qty.</th>
              <th>Plan</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            {selectedItems && selectedItems.length > 0 ? (
              selectedItems.map((item, i) => (
                <tr key={i}>
                  <td>{item.quantity || 1}</td>
                  <td>{item.item}</td>
                  <td>${item.price}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <td>Total Price</td>
              <td></td>
              <td>${totalPrice}</td>
            </tr>
          </tfoot>
        </Table>
      </Modal.Body>
      <Modal.Footer className="text-center">
        {isLoading ? (
          <h3 className="text-center" style={{ textAlign: "center" }}>
            Loading...
          </h3>
        ) : (
          <StripeCheckout
            className="center"
            stripeKey={stripKEY}
            token={handleToken}
            amount={totalPrice * 100}
            name="Protectall Protection Plans"
            billingAddress
          />
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default CheckoutPaymentModel;
